import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
  RULER_CHANGES: 'RULER_CHANGES',
  RULER_LINES_CHANGES: 'RULER_LINES_CHANGES',
  REINITIALIZE: 'REINITIALIZE',

}

export const rulerEventsBroker = new EventBroker();
